import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Info from '../../../../../components/channel-configuration/info';
import { ChannelBox } from '../../../components/channel/box';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { BlindCalibration } from '../components/blind-calibration';
import { BlindSensitivity } from '../components/blind-sensitivity';
import { InputsType } from '../components/inputs-type';
import SwapIn from '../components/swap-in';
import { useConfiguration } from '../hooks/use-configuration';
import { usePartialConfigChanged } from '../hooks/use-partial-config-changed';
import { InfoPageType } from '../types';

type CoverConfigurationProps = {
  setInfoPage: Dispatch<SetStateAction<InfoPageType>>;
};

const CoverConfiguration: React.FC<CoverConfigurationProps> = ({ setInfoPage }) => {
  const { t } = useTranslation('configuration');
  const { channelId } = useParams<{ channelId: string }>();
  const { channel } = useDevicesAndChannelsContext();
  const ChannelId = channelId ?? '';
  const { setTimeoutError } = usePartialConfigChanged({ channelId: ChannelId });
  const { swapOut } = useConfiguration({ channel });

  if (!channel) return null;

  return (
    <>
      <Info title={t('channelTest')} onClick={() => setInfoPage(InfoPageType.CHANNEL)} />
      <ChannelBox channel={channel} isListItem noRedirect />
      <div className="row_container max-width-desktop">
        <button className="button button--secondary" onClick={swapOut}>
          {t('reverseOutputs')}
        </button>
      </div>
      <div className="row_container margin_top">
        <span>{t('reverseOutputsContent')}</span>
      </div>
      <hr />
      <Info title={t('calibration')} onClick={() => setInfoPage(InfoPageType.CALIBRATION)} />
      <BlindCalibration channel={channel} />
      <BlindSensitivity setTimeoutError={setTimeoutError} />

      <SwapIn channel={channel} setInfoPage={setInfoPage} />

      <InputsType setInfoPage={setInfoPage} />
    </>
  );
};

export default CoverConfiguration;
